import { Coffee } from "@repo/icons";
import {
  EmptyStateDescription,
  EmptyStateIcon,
  EmptyStateRoot,
  EmptyStateTitle,
} from "@/components/empty-state";

interface CommunityEmptyStateProps {
  tabSelectedLabel: string;
}

export const CommunityEmptyState = ({
  tabSelectedLabel,
}: CommunityEmptyStateProps): JSX.Element => {
  const descriptionDictionary: Record<string, string> = {
    Todos: "Tente ajustar os filtros para descobrir quem está procurando.",
    Favoritos: "Você ainda não adicionou nada aos favoritos.",
  };

  const textDescription =
    descriptionDictionary[tabSelectedLabel] || descriptionDictionary.todos;

  return (
    <div className="pt-8">
      <EmptyStateRoot>
        <EmptyStateIcon icon={Coffee} />
        <EmptyStateTitle>
          <h4>Ops! </h4>
          <h4>Não encontramos nada na sua busca.</h4>
        </EmptyStateTitle>
        <EmptyStateDescription>{textDescription}</EmptyStateDescription>
      </EmptyStateRoot>
    </div>
  );
};
